import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=22220e9e&"
import script from "./pager.vue.ts?vue&type=script&lang=ts&"
export * from "./pager.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports